<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Cajas</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                <template v-if="open_cash">
                    <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2"
                        @click.prevent="clickDownloadGeneral()"><i class="fas fa-shopping-cart"></i> Reporte
                        general</button>

                    <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2" @click.prevent="clickCreate()"><i
                            class="fas fa-shopping-cart"></i> Aperturar caja chica POS</button>
                </template>
                <!-- <template v-else>                 -->
                <!-- <button type="button" class="btn btn-success btn-sm  mt-2 mr-2" @click.prevent="clickOpenPos()"><i class="fas fa-shopping-cart" ></i> Aperturar punto de venta</button> -->
                <!-- </template> -->
            </div>
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Listado de cajas</h3>
            </div>
            <div class="card-body">
                <data-table :resource="resource">
                    <tr slot="heading">
                        <th>#</th>
                        <th>Referencia</th>
                        <th>Vendedor</th>
                        <th class="text-center">Apertura</th>
                        <th class="text-center">Cierre</th>
                        <th class="text-right">Inicial</th>
                        <th class="text-right">Final</th>
                        <!-- <th>Ingreso</th> -->
                        <!-- <th>Egreso</th> -->
                        <th class="text-center">Estado</th>
                        <th class="text-center">Acciones</th>
                    </tr>
                    <tr slot-scope="{ index, row }">
                        <td>{{ index }}</td>
                        <td>{{ row.reference_number }}</td>
                        <td>{{ row.user }}</td>
                        <td class="text-center">{{ row.opening }}</td>
                        <td class="text-center">{{ row.closed }}</td>
                        <td class="text-right table-money">{{ row.beginning_balance }}</td>
                        <td class="text-right table-money">{{ row.final_balance }}</td>
                        <!-- <td>{{ row.income }}</td>
                        <td>{{ row.expense }}</td> -->
                        <td class="text-center">
                            <span class="badge" :class="row.state ? 'badge-success' : 'badge-danger'">
                                {{ row.state_description }}
                            </span>
                        </td>
                        <td class="text-center">
                            <div class="cash-actions-clean">

                                <div class="btn-group dropup">
                                    <el-popover placement="left-start" width="280" trigger="click"
                                        popper-class="cash-report-popover">

                                        <div class="cash-report-menu">
                                            <div class="cash-report-title">Reportes generales</div>
                                            <button class="cash-report-item"
                                                @click="clickDownloadReport(row.id, 'a4')">PDF
                                                A4</button>
                                            <button class="cash-report-item"
                                                @click="clickDownloadReport(row.id, 'ticket')">PDF
                                                Ticket</button>
                                            <button class="cash-report-item"
                                                @click="clickDownloadReport(row.id, 'excel')">Excel</button>
                                            <button class="cash-report-item"
                                                @click="clickReportSummaryDailyOperations(row.id)">Resumen de
                                                Operaciones
                                                Diarias</button>
                                            <button class="cash-report-item"
                                                @click="clickReportCashWithPayments(row.id)">Reporte general caja
                                                V2</button>

                                            <div class="cash-report-divider"></div>
                                            <div class="cash-report-title">Reporte efectivo</div>

                                            <button class="cash-report-item"
                                                @click="clickDownloadReportCash(row.id, 'excel')">Reporte Efectivo -
                                                Excel</button>
                                            <button class="cash-report-item"
                                                @click="clickDownloadReportIncomeEgress(row.id)">Ingresos y
                                                egresos</button>
                                            <button class="cash-report-item"
                                                @click="clickReportPaymentsAssociatedCash(row.id)">Pagos asociados a
                                                caja</button>

                                            <div class="cash-report-divider"></div>
                                            <div class="cash-report-title">Reporte productos</div>

                                            <button class="cash-report-item"
                                                @click="clickDownloadProducts(row.id, 'pdf')">Punto
                                                de venta - PDF</button>
                                            <button class="cash-report-item"
                                                @click="clickDownloadProducts(row.id, 'excel')">Punto de venta -
                                                Excel</button>
                                            <button class="cash-report-item"
                                                @click="clickDownloadProducts(row.id, 'pdf', true)">Venta rápida -
                                                PDF</button>

                                            <div class="cash-report-divider"></div>
                                            <div class="cash-report-title">Ingresos</div>

                                            <button class="cash-report-item"
                                                @click="clickDownloadIncomeSummary(row.id)">R.
                                                Ingreso</button>
                                        </div>

                                        <button slot="reference" type="button" class="btn btn-xs btn-report-soft">
                                            Reportes
                                        </button>
                                    </el-popover>

                                </div>

                                <div class="btn-group">
                                    <el-popover placement="left-start" width="220" trigger="click"
                                        popper-class="cash-report-popover">

                                        <div class="cash-report-menu">
                                            <div class="cash-report-title">Acciones</div>

                                            <button class="cash-report-item" @click="clickOptions(row.id)">
                                                C. Electrónico
                                            </button>

                                            <template v-if="row.state">
                                                <button class="cash-report-item" @click="clickCloseCash(row.id)">
                                                    Cerrar caja
                                                </button>

                                                <button v-if="typeUser === 'admin'" class="cash-report-item"
                                                    @click="clickCreate(row.id)">
                                                    Editar
                                                </button>

                                                <button v-if="typeUser === 'admin'"
                                                    class="cash-report-item cash-report-item-danger"
                                                    @click="clickDelete(row.id)">
                                                    Eliminar
                                                </button>
                                            </template>
                                        </div>

                                        <button slot="reference" type="button" class="btn btn-xs btn-action-soft">
                                            Acciones <span class="caret"></span>
                                        </button>
                                    </el-popover>
                                </div>

                            </div>
                        </td>
                    </tr>
                </data-table>
            </div>
        </div>

        <cash-form :showDialog.sync="showDialog" :typeUser="typeUser" :recordId="recordId"></cash-form>

        <cash-options :showDialog.sync="showDialogOptions" :recordId="recordId"></cash-options>
    </div>
</template>

<script>

import DataTable from '../../../components/DataTable.vue'
import { deletable } from '../../../mixins/deletable'
import CashForm from './form.vue'
import CashOptions from './partials/options.vue'

export default {
    mixins: [deletable],
    components: { DataTable, CashForm, CashOptions },
    props: ['typeUser'],
    data() {
        return {
            showDialog: false,
            showDialogOptions: false,
            open_cash: true,
            resource: 'cash',
            recordId: null,
            cash: null,
        }
    },
    async created() {

        /*await this.$http.get(`/${this.resource}/opening_cash`)
            .then(response => {
                this.cash = response.data.cash
                this.open_cash = (this.cash) ? false : true
            })*/

        /*this.$eventHub.$on('openCash', () => {
            this.open_cash = false
        })*/

    },
    methods: {
        clickOptions(recordId) {
            this.showDialogOptions = true
            this.recordId = recordId
        },
        clickDownloadReport(id, template, mm = 80) {
            if (template == 'ticket') {
                window.open(`/${this.resource}/report-${template}/${id}/${mm}`, '_blank');
            } else if (template == 'simple_a4') {
                window.open(`/${this.resource}/simple/report-a4/${id}/`, '_blank');
            } else {
                window.open(`/${this.resource}/report-${template}/${id}`, '_blank');

            }
        },
        clickDownload(id) {
            window.open(`/${this.resource}/report/${id}`, '_blank');
        },
        clickDownloadIncomeSummary(id) {
            window.open(`/${this.resource}/report/income-summary/${id}`, '_blank');
        },
        clickCreate(recordId = null) {
            this.recordId = recordId
            this.showDialog = true
        },
        clickCloseCash(recordId) {

            this.recordId = recordId
            const h = this.$createElement;
            this.$msgbox({
                title: 'Cerrar caja chica POS',
                type: 'warning',
                message: h('p', null, [
                    h('p', { style: 'text-align: justify; font-size:15px' }, '¿Está seguro de cerrar la caja?'),
                ]),

                showCancelButton: true,
                confirmButtonText: 'Cerrar',
                cancelButtonText: 'Cancelar',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        this.createRegister(instance, done)
                    } else {
                        done();
                    }
                }
            })
                .then(action => {
                })
                .catch(action => {
                });



        },
        createRegister(instance, done) {

            instance.confirmButtonLoading = true;
            instance.confirmButtonText = 'Cerrando caja...';

            this.$http.get(`/${this.resource}/close/${this.recordId}`)
                .then(response => {
                    if (response.data.success) {
                        this.$eventHub.$emit('reloadData')
                        this.open_cash = true
                        this.$message.success(response.data.message)
                    } else {
                        console.log(response)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .then(() => {
                    instance.confirmButtonLoading = false
                    instance.confirmButtonText = 'Iniciar prueba'
                    done()
                })

        },
        clickOpenPos() {
            window.open('/pos')
        },
        clickDelete(id) {
            this.destroy(`/${this.resource}/${id}`).then(() =>
                this.$eventHub.$emit('reloadData')
            )
        },
        clickDownloadGeneral() {
            window.open(`/${this.resource}/report`, '_blank');
        },
        clickDownloadProducts(id, type, is_garage = false) {

            if (type == 'excel') {
                window.open(`/${this.resource}/report/products-excel/${id}`, '_blank');
                return
            }

            window.open(`/${this.resource}/report/products/${id}/${is_garage}`, '_blank');
            // window.open(`/${this.resource}/report/products/${id}`, '_blank');

        },
        clickDownloadReportCash(id, type) {

            if (type == 'excel') {
                window.open(`/${this.resource}/report/cash-excel/${id}`, '_blank');
                return
            }

            window.open(`/${this.resource}/report/products/${id}`, '_blank');

        },
        clickDownloadReportIncomeEgress(id) {
            window.open(`/${this.resource}/report-cash-income-egress/${id}`, '_blank');
        },
        clickReportSummaryDailyOperations(id) {
            window.open(`/cash-reports/summary-daily-operations/${id}`, '_blank');
        },
        clickReportPaymentsAssociatedCash(id) {
            window.open(`/cash-reports/payments-associated-cash/${id}`, '_blank');
        },
        clickReportCashWithPayments(id) {
            window.open(`/cash-reports/general-with-payments/${id}`, '_blank');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/cash/index.vue